import { translate } from '../translation';
import { getLabel } from './view_state';

export const getDisplayText = (selectedOptions) => {
  if (!selectedOptions.length) {
    return '';
  }

  if (selectedOptions.length === 1) {
    return getLabel(selectedOptions[0]);
  }

  return selectedOptions
    .filter((option) => !option.children)
    .map((option) => option.label)
    .join(', ');
};

export const getAccordionLabel = (selectedOptions) => {
  if (!selectedOptions.length) {
    return null;
  }

  if (selectedOptions.length > 1) {
    return translate('common.search_form.accordion.multiple_value_selected', { count: selectedOptions.length });
  }

  return selectedOptions[0].label;
};
